/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import { startCase, capitalize, lowerCase } from 'lodash';

const ListGroupItemOtherInteraction = ({ data }) => {
  const detailObject = data.attributes.detailObject
    ? JSON.parse(data.attributes.detailObject)
    : data.attributes.detail
      ? data.attributes.detail
      : {};

  return (
    <span className="ml-2">
      {capitalize(startCase(detailObject.type))}
      {detailObject.name &&
        ` with ${detailObject.name}`}{' '}
      {`via ${lowerCase(detailObject.method)}.`}
    </span>
  );
};

ListGroupItemOtherInteraction.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ListGroupItemOtherInteraction;
